import styled from "@emotion/styled";
import { COLOR_WHITE_20 } from "shared/theme/colors";
import bg from "shared/theme/images/purplebackground.png";

const BaseCard = styled("div")`
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 115px;
  width: 160px;
`;

export const TitleSkeleton = styled("div")`
  background-color: ${COLOR_WHITE_20};
  border-radius: 100px;
  width: 88px;
  height: 12px;
`;

export const DescriptionSkeleton = styled(TitleSkeleton)`
  width: 114px;
  height: 9px;
`;

export const PurpleCard = styled(BaseCard)`
  background: linear-gradient(
    to bottom,
    rgba(111, 82, 187, 1),
    rgba(79, 54, 145, 1)
  );
`;

export const RedCard = styled(BaseCard)`
  background: linear-gradient(
    to bottom,
    rgba(245, 66, 83, 1),
    rgba(174, 0, 18, 1)
  );
`;

export const OrangeCard = styled(BaseCard)`
  background: linear-gradient(
    to bottom,
    rgba(254, 125, 6, 1),
    rgba(235, 99, 0, 1)
  );
`;

export const Wrapper = styled("div")`
  background: linear-gradient(
      to bottom,
      rgba(58, 18, 115, 1),
      rgba(50, 7, 102, 1),
      rgba(51, 10, 105, 1),
      rgba(59, 15, 117, 1),
      rgba(53, 12, 109, 1)
    ),
    url(${bg});
  background-size: cover;
  padding: 16px;
  border-radius: 17px;
  margin-top: 16px;
`;

export const GridContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  justify-content: start;
  margin-top: 16px;
`;
